import styled from 'styled-components';
import { iOS } from 'utils/platform';

const Header = styled.header`
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  background: #ffffff;
  z-index:1000;
  padding: 0 56px;
  width: 100vw;
  height: 56px;
  ${iOS() &&
    `
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
      height: calc(56px + env(safe-area-inset-top));  
`}
  border-bottom: 1px solid #A6A6A6;

  

  h1 {
    margin: 0 auto;
    font-weight: normal;
    font-size: 24px;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const Styled = {
  Header,
};
